import React, { ReactNode } from 'react';
import './toggle.scss';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Text beside the switch; clicking it toggles. Without one, give `aria-label`. */
  label?: ReactNode;
  disabled?: boolean;
  /** `sm` fits a table row; `md` is the field size. */
  size?: 'sm' | 'md';
  id?: string;
  'aria-label'?: string;
  className?: string;
}

/**
 * A switch. Replaces the bare checkboxes the modal used for yes/no facts
 * (startup meeting held, QA required, civil scope). `role="switch"` so a
 * reader announces on/off rather than checked.
 */
const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  size = 'md',
  id,
  'aria-label': ariaLabel,
  className = '',
}) => {
  const control = (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={label ? undefined : ariaLabel}
      disabled={disabled}
      className={`toggle toggle--${size} ${checked ? 'is-on' : ''} ${label ? '' : className}`.trim()}
      onClick={() => onChange(!checked)}
    >
      <span className="toggle__track">
        <span className="toggle__thumb" />
      </span>
    </button>
  );

  if (!label) return control;

  return (
    <label className={`toggle-field ${disabled ? 'is-disabled' : ''} ${className}`.trim()}>
      {control}
      <span className="toggle-field__label">{label}</span>
    </label>
  );
};

export default Toggle;
